<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" label-width="80px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="跟进人" prop="managerId">
            <el-select
              v-model="queryParams.managerId"
              placeholder="请选择"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in staffOptions"
                :key="dict.userId"
                :label="dict.nickName"
                :value="dict.userId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="用户姓名" prop="nickName">
            <el-input v-model="queryParams.nickName" placeholder="请输入用户姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="手机号" prop="phoneNumber">
            <el-input v-model="queryParams.phoneNumber" placeholder="请输入手机号" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="CRM关联" prop="crmFlag">
            <el-select v-model="queryParams.crmFlag" placeholder="请选择" clearable style="width:100%">
              <el-option
                v-for="dict in relationStatus"
                :key="dict.code"
                :label="dict.name"
                :value="dict.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="用户姓名" min-width="120" align="center" prop="nickName" />
      <el-table-column label="备注" min-width="100" align="center" prop="remarkName" />
<!--      <el-table-column label="手机号" min-width="100" align="center" prop="phoneNumber">-->
<!--        <template slot-scope="scope">-->
<!--          <template v-if="scope.row.attentionCompany">-->
<!--            {{scope.row.phoneNumber}}-->
<!--          </template>-->
<!--          <template v-else>-->
<!--            {{ scope.row.phoneNumber.substring(0, 3)+"****"+ scope.row.phoneNumber.substr(scope.row.phoneNumber.length-4)}}-->
<!--          </template>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="CRM关联" min-width="60" align="center" prop="crmFlag">
        <template slot-scope="scope">{{scope.row.crmFlag === 0 ? '否':'是'}}</template>
      </el-table-column>
      <el-table-column label="潜在线索" min-width="60" align="center" prop="potentialClueCount" />
      <el-table-column label="最新轨迹" min-width="120" align="center" prop="lastActiveTime" />
      <el-table-column label="关注时间" min-width="120" align="center" prop="focusTime" />
      <el-table-column label="跟进人" min-width="100" align="center" prop="managerName" />
      <el-table-column label="操作" min-width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSee(scope.row)">查看</el-button>
          <el-button type="text" @click="handleDistribute(scope.row)">分配</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryContactList"
    />
    <AddManageDialog ref="addManageDialogRef" @success="queryContactList"></AddManageDialog>
  </div>
</template>

<script>
import { queryContactList, assign } from "@/api/saas/package";
import { listUserWithOutDataScope } from "@/api/system/user";
import AddManageDialog from './components/addManageDialog'

export default {
  name: "ContactList",
  components: {
    AddManageDialog
  },
  data() {
    return {
      manageOptions: [], // 跟进人
      staffOptions: [],
      relationStatus: [
        {
          // 是否CRM关联
          code: 0,
          name: "否"
        },
        {
          code: 1,
          name: "是"
        }
      ],
      total: 0,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        crmFlag: null,
        nickName: null,
        phoneNumber: null,
        managerId: null
      },
      rules: {
        managerId: [
          { required: true, message: "请选择跟进人", trigger: "change" }
        ]
      },
      dataList: [],
      current: {}, // 当前潜在联系人
      data: {
        managerId: null
      }
    };
  },
  created() {
    this.listUserWithOutDataScope()
    this.handleQuery();
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    handleSee(row) {
      this.$router.push({
        path: "/potential/contact/detail",
        query: {
          id: row.id
        }
      });
    },
    handleDistribute(row) {
      this.$refs.addManageDialogRef.open(row.id)
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.queryContactList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.userId = null;
      this.handleQuery();
    },
    queryContactList() {
      this.loading = true;
      queryContactList(this.queryParams)
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total;
        })
        .catch(error => {
          this.loading = false;
        });
    },

    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          assign({
            potentialContactId: this.current.id,
            managerId: this.data.managerId
          })
            .then(response => {
              this.visible = false;
              this.queryContactList();
            })
            .catch(error => {
              this.loading = false;
            });
        }
      });
    },
    listUserWithOutDataScope() {
      listUserWithOutDataScope().then(response => {
        this.staffOptions = response.rows;
      });
    },
    /** 详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/business/detail/" + row.id);
    }
  }
};
</script>
